import React, { useEffect } from 'react'
import { faAdd, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcButton,
  DcDiv,
  DcDropDown,
  DcFlexBox,
  PixelIcon,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
} from 'pixel-base'

import { get, getCategories } from 'utils/api-routes.util'
import CategoryForm from './components/CategoryForm'
import {
  IStoreCollection,
  IStoreInfo,
  IStoreListState,
} from '../../../../../decl'

const breadcrumbs = [
  {
    name: 'Products Collections',
    active: true,
  },
]
const Category = () => {
  const [categories, setCategories] = React.useState<IStoreCollection[]>([])
  const [showModal, setShowModal] = React.useState(false)
  const [tableLoading, setTableLoader] = React.useState(true)
  const [storeList, setStoreList] = React.useState<IStoreListState>({
    allStores: [],
    filteredStores: null,
  })

  const getAllCategories = (storeId: string | null) => {
    setTableLoader(true)
    getCategories(storeId).subscribe((res) => {
      const response = res as { response: { data: IStoreCollection[] } }
      setCategories(response.response.data)
      setTableLoader(false)
    })
  }

  const getStoreslist = () => {
    setTableLoader(true)
    get('/tenant/stores').subscribe((res) => {
      const response = res as { response: { data: IStoreInfo[] } }
      setStoreList({ ...storeList, allStores: response.response.data })
      setTableLoader(false)
    })
  }

  useEffect(() => {
    getStoreslist()
  }, [])

  useEffect(() => {
    getAllCategories(storeList.filteredStores?.toString() || null)
  }, [storeList.filteredStores])

  const columns = [
    {
      dataKey: 'id',
      name: 'Collection ID',
      sortable: true,
      selector: (row: IStoreCollection) => row.collection_id.id || '--',
    },
    {
      dataKey: 'id',
      name: 'Store ID',
      sortable: true,
      selector: (row: IStoreCollection) => row.store_id || '--',
    },
    {
      dataKey: 'name',
      name: 'Collection Name',
      sortable: true,
      selector: (row: IStoreCollection) =>
        row.collection_id.source_collection_name || '--',
    },

    {
      dataKey: 'is smart collection',
      name: 'Is Smart Collection',
      sortable: true,
      selector: (row: IStoreCollection) => (
        <PixelIcon
          color={row.collection_id.is_smart_collection ? 'green' : 'red'}
          icon={row.collection_id.is_smart_collection ? faCheck : faTimes}
        />
      ),
    },
  ]
  return (
    <>
      <DcFlexBox
        height="60px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer padding="0px">
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              height="auto"
              padding="5px 20px"
              justifyContent="flex-end"
              alignItems="center"
              gap="5px"
            >
              <DcDiv width="30%" style={{ maxWidth: '300px' }}>
                <DcDropDown
                  dropdownSize="sm"
                  // error={
                  //   error.field === 'is_business_account' && error.error !== ''
                  //     ? error.error
                  //     : null
                  // }
                  label="All Stores*"
                  name="all_stores"
                  value={storeList.filteredStores || ''}
                  onChange={(e) => {
                    setStoreList({
                      ...storeList,
                      filteredStores: e.target.value,
                    })
                  }}
                  placeholder="All Stores*"
                  required
                  options={[
                    {
                      label: 'All Stores',
                      value: null,
                    },
                    ...[...storeList.allStores].map((item: IStoreInfo) => ({
                      label: item.store_name,
                      value: item.store_id.toString(),
                    })),
                  ]}
                />
              </DcDiv>
              <DcButton size="sm" disabled onClick={() => setShowModal(true)}>
                <PixelIcon color="#fff" icon={faAdd} /> Add Collections
              </DcButton>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section
          style={{
            padding: '20px',
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
          }}
        >
          <SectionContent>
            <PixelTable
              columns={columns}
              data={categories}
              fixedHeader
              fixedHeaderScrollHeight="calc(100vh - 160px)"
              progressPending={tableLoading}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      {showModal && (
        <PixelModal
          title={'Add Category'}
          handleClose={() => setShowModal(false)}
          show={showModal}
        >
          <CategoryForm
            show={showModal}
            categories={{}}
            handleClose={(data) => {
              setCategories([data, ...categories])
              setShowModal(false)
            }}
          />
        </PixelModal>
      )}
    </>
  )
}

export default Category
